var Handlebars = require('handlebars/dist/handlebars.runtime');
var loop = require('./loop.helper');
var json = require('./json.helper');
var add = require('./math.add.helper');

Handlebars.registerHelper('loop', loop);
Handlebars.registerHelper('json', json);
Handlebars.registerHelper('add', add);


// WEBPACK FOOTER //
// ./shared/templates/helpers/helpers.js